// Normalize potentially bad Firebase Storage URLs and pick a good fallback per visibility.

export function fixUrl(u?: string | null): string | null {
  if (!u) return null;
  let s = String(u).trim();
  if (!s) return null;

  // Collapse accidental double-host
  s = s.replace(/firebasestorage\.app\.firebasestorage\.app/gi, "firebasestorage.app");

  // Non-HTTP: treat as site-relative
  if (!/^https?:\/\//i.test(s)) {
    if (!s.startsWith("/")) s = `/${s}`;
    s = s.replace(/^\/public\//i, "/");
    // If it's just a filename, assume it's under /events/seeded-venues
    if (/^\/[^/]+\.(png|jpe?g|webp|gif)$/i.test(s)) {
      return `/events/seeded-venues${s}`;
    }
    return s;
  }

  try {
    const url = new URL(s);
    const isVanity = /\.firebasestorage\.app$/i.test(url.host);
    const hasOPath = /^\/o\//.test(url.pathname);
    if (isVanity && !hasOPath) {
      const bucketId = url.host.replace(/\.firebasestorage\.app$/i, ".appspot.com");
      const objectPath = encodeURIComponent(url.pathname.replace(/^\/+/, ""));
      const token = new URLSearchParams(url.search).get("token");
      const tok = token ? `&token=${encodeURIComponent(token)}` : "";
      return `https://firebasestorage.googleapis.com/v0/b/${bucketId}/o/${objectPath}?alt=media${tok}`;
    }
  } catch {}
  return s;
}

export function eventFallbackByVisibility(visibility?: string | null): string {
  return String(visibility).toLowerCase() === "private"
    ? "/events/private.png"
    : "/events/public.png";
}

export function buildEventGallery(ev: {
  images?: (string | null | undefined)[];
  organizerAvatarUrl?: string | null;
  visibility?: string | null;
}): string[] {
  const fallback = eventFallbackByVisibility(ev.visibility);
  const raw = [
    ...(Array.isArray(ev.images) ? ev.images : []),
    ev.organizerAvatarUrl || null,
  ].filter(Boolean) as string[];
  const fixed = raw.map((u) => fixUrl(u)!).filter(Boolean) as string[];
  return fixed.length ? fixed.slice(0, 4) : [fallback];
}
